import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import ProjectDetailPageUI from './ProjectDetailPageUI.js'

class ProjectDetailPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null,
      createProjectMode: false,
      copyToClipboardText: null,
      updateProjectMode: false
    }
  }

  render() {
    return (
      <ProjectDetailPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.state.loan}
        account={this.state.account}
        onRefreshClick={this.onRefreshClick}
        customerList={this.state.customerList}
        filteredCustomerList={this.state.filteredCustomerList}
        selectedCustomer={this.state.selectedCustomer}
        createProjectMode={this.state.createProjectMode}
        onCreateProjectClick={() => { this.setState({ createProjectMode: true }) }}
        onCancelCreateProject={() => { this.setState({ createProjectMode: false }) }}
        updateProjectMode={this.state.updateProjectMode}
        onProjectUpdateClick={this.onProjectUpdateClick}
        onProjectUpdateCancel={() => { this.setState({ updateProjectMode: false }) }}
        selectedProject={this.state.selectedProject}
      />
    )
  }

  onProjectUpdateClick = (event) => {
    let projectId = event.currentTarget.getAttribute('data-project-id')
    let selectedProject = this.state.loan.termSheet.projectList.filter(p => p.projectId === projectId)[0]
    this.setState({ updateProjectMode: true, selectedProject: selectedProject })
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    let context = this.props.context
    this.setState({ errorList: response.errorList, loan: response.loan, accountId: response.loan.accountId }, () => {
      if (response.errorList.length == 0) {
        this.getAccount(context, response.loan.accountId)
        this.getProject(context, response.loan)
        this.getReferenceProjects(context, response.loan)
        this.getCustomers(context, response.loan.accountId)
      }
    })
  }

  getAccount(context, accountId) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${accountId}`,
      cacheKey: CacheKeys.Accounts(accountId),
      callback: this.getAccountCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getAccountCallback = (response) => {
    this.setState({ account: response.account })
  }

  getCustomers(context, accountId) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${accountId}/customers`,
      cacheKey: CacheKeys.Customers(accountId),
      callback: this.getCustomersCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getCustomersCallback = (response) => {
    let filteredCustomerList = response.customerList.map((customer) => {
      return { key: customer.customerId, value: customer.customerName }
    })
    let selectedCustomer = response.customerList.filter(c => c.customerId === this.state.loan.customerId)[0]
    this.setState({
      customerList: response.customerList,
      filteredCustomerList: filteredCustomerList,
      selectedCustomer: selectedCustomer
    })
  }

  getProject = (context, loan) => {
    if (!loan.termSheet.projectId)
      return
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${loan.loanId}/projects/${loan.termSheet.projectId}`,
      cacheKey: CacheKeys.ProjectByLoanId(loan.loanId),
      callback: this.getProjectCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getProjectCallback = (response) => {
    let loan = this.state.loan
    loan.termSheet.project = response.project
    this.setState({
      errorList: response.errorList,
      loan: this.state.loan,
    })
  }

  getReferenceProjects = (context, loan) => {
    let projectIdList = loan.termSheet.referenceProjectIdList
    if (!projectIdList || projectIdList.length == 0)
      return
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${loan.loanId}/referenceProjects`,
      cacheKey: CacheKeys.ReferenceProjectsByLoanId(loan.loanId),
      callback: this.getReferenceProjectsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getReferenceProjectsCallback = (response) => {
    let loan = this.state.loan
    loan.termSheet.referenceProjectList = response.projectList
    this.setState({
      errorList: response.errorList,
      loan: this.state.loan,
    })
  }

  getBillList = (context, loan) => {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${loan.loanId}/bills`,
      cacheKey: CacheKeys.BillsByLoanId(loan.loanId),
      callback: this.getBillListCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getBillListCallback = (response) => {
    let loan = this.state.loan
    loan.disbursement.billList = response.billList
    this.setState({
      errorList: response.errorList,
      loan: this.state.loan,
    })
  }

  getBankAccount(context, accountId) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${accountId}/bankAccounts`,
      cacheKey: CacheKeys.BankAccounts(accountId),
      callback: this.getBankAccountCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  onRefreshClick = (noBusy) => {
    let loan = this.state.loan
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Loan(loan.loanId))
    CacheManager.removeObject(CacheKeys.ReferenceProjectsByLoanId(loan.loanId))
    CacheManager.removeObject(CacheKeys.ProjectByLoanId(loan.loanId))
    // CacheManager.removeObject(CacheKeys.BankAccounts(loan.accountId))
    CacheManager.removeObject(CacheKeys.Customers(loan.accountId))
    CacheManager.removeObject(CacheKeys.Accounts(loan.accountId))
    if (noBusy === 'noBusy') {
      this.getLoan(context)
    }
    else {
      this.setState({
        loan: null,
        errorList: null,
      })
      this.getLoan(context)
    }
  }
}

export default withRouter(ProjectDetailPageSF)
